import { render } from "./TasksSvg.vue?vue&type=template&id=51c47e94"
const script = {}
script.render = render

export default script